import { render, staticRenderFns } from "./PopularBroadcasts.vue?vue&type=template&id=489b4105&scoped=true"
import script from "./PopularBroadcasts.vue?vue&type=script&lang=ts"
export * from "./PopularBroadcasts.vue?vue&type=script&lang=ts"
import style0 from "./PopularBroadcasts.vue?vue&type=style&index=0&id=489b4105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b4105",
  null
  
)

export default component.exports